export default {"src":"/_next/static/media/landline-icon.9ee4ee58.svg","height":513,"width":513};